import React, { useEffect, useRef, useState } from "react";
import { StyleSheet, TextInput, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import {
    getAddressListAndUpdateBilling,
    getAddressListAndUpdateDelivery,
    getUserAddressList,
} from "appRedux/reducers/orderSlice";
import { router, useLocalSearchParams } from "expo-router";
import { useDispatch, useSelector } from "react-redux";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import AddressCountryModal from "components/AddressCountryModal";
import Buttons from "components/Buttons";
import { Colors } from "colors";
import { Image } from "react-native";
import ImageView from "../src/image";
import ParentScrollView from "components/ParentScrollView";
import { REGEX } from "utils/Constants";
import SideProfileComp from "components/profile/SideProfileComp";
import { TouchableOpacity } from "react-native";
import VText from "components/VText";
import { addNewAddress } from "appRedux/reducers/cartSlice";
import { trackV2 } from "utils/Segment";

const AddAddress = ({}) => {
    const local = useLocalSearchParams();
    const addressId = local?.id;
    const isProfile = local?.isProfile || false;
    const isOrderSummaryCall = local?.isOrder || false;
    const isBilling = local?.isBilling || false;
    const isGuest = local?.isGuest || false;
    const redirectTo = local?.redirectTo || "";

    const [customerName, setCustomerName] = useState("");
    const [emailId, setEmailId] = useState("");
    const [addressName, setAddressName] = useState("");
    const [phone, setphone] = useState("");
    const [errorObj, setErrorObj] = useState({});
    const [addressLine1, setaddressLine1] = useState("");
    const [addressLine2, setaddressLine2] = useState("");
    const [city, setcity] = useState("");
    const [state, setstate] = useState("");
    const [coords, setCoords] = useState(null);
    const [zipCode, setzipCode] = useState("");
    const [countryCode, setCountryCode] = useState("+1");
    const [isDisabled, setIsDisabled] = useState(true);
    const [loading, setLoading] = useState(false);

    const userId = useSelector((state) => state.AuthReducer.userId);
    const userAddressList = useSelector((state) => state.OrderReducer.userAddressList);
    const userProfile = useSelector((state) => state.ProfileReducer.profileData);
    const addressCountryModalRef = useRef(null);
    const currentCountry = useSelector((state) => state.StoredutilsSlice.country);
    const countries = useSelector((state) => state.StoredutilsSlice.countries);
    const [country, setcountry] = useState(currentCountry.name);
    const [selectedCountry, setSelectedCountry] = useState(currentCountry);

    const dispatch = useDispatch();
    const localGender = local?.gender || "female";

    const nameInputRef = useRef(null);
    const phoneInputRef = useRef(null);
    const addressLine1InputRef = useRef(null);
    const addressLine2InputRef = useRef(null);
    const cityInputRef = useRef(null);
    const stateInputRef = useRef(null);
    const zipCodeInputRef = useRef(null);
    const countryInputRef = useRef(null);

    useEffect(() => {
        if (addressId) {
            dispatch(getUserAddressList());
        }
    }, [addressId]);

    useEffect(() => {
        if (userProfile?.emailId) {
            setEmailId(userProfile?.emailId);
        }
    }, [userProfile]);

    useEffect(() => {
        if (addressId && userAddressList && Array.isArray(userAddressList)) {
            const address = userAddressList?.find((o) => o?.id == addressId);
            setCustomerName(address?.name || "");
            setEmailId(address?.emailId || "");
            setAddressName(address?.type || "");
            setphone(address?.mobileNumber || "");
            setaddressLine1(address?.addressLine1 || "");
            setaddressLine2(address?.addressLine2 || "");
            setzipCode(address?.pincode?.toString() || "");
            setcity(address?.city || "");
            setstate(address?.state || "");
            setcountry(address?.country || "United States of America");
            handleCountryChange({
                name: address?.country || "United States of America",
                imageUrl:
                    countries?.find((o) => o?.name === address?.country)?.imageUrl ||
                    "https://vetirapp-images.s3.us-east-1.amazonaws.com/USA.webp",
            });
        }
    }, [addressId, userAddressList]);

    useEffect(() => {
        if (
            addressName !== "" &&
            phone !== "" &&
            addressLine1 !== "" &&
            city !== "" &&
            state !== "" &&
            zipCode !== "" &&
            country !== "" &&
            emailId !== ""
        ) {
            setIsDisabled(false);
        } else {
            setIsDisabled(true);
        }
    }, [
        addressLine1,
        addressLine2,
        city,
        country,
        addressName,
        phone,
        state,
        zipCode,
        emailId,
        selectedCountry,
        countryCode,
    ]);

    const onChangePhone = (value) => {
        if (phone.length === 0) {
            setphone(`${countryCode}${value}`.trim());
        } else if (value.length === 1 && value[0] && value[1] === "1") {
            setphone("");
        } else {
            setphone(value.trim());
        }
    };

    const handleCountryChange = (item) => {
        setSelectedCountry(item);
        addressCountryModalRef.current.hide();
        setcountry(item.name);
        if (item.name !== "United States of America") {
            fetch(`https://restcountries.com/v3.1/name/${item.name}`)
                .then((response) => response.json())
                .then((data) => {
                    const countryCode = data[0].idd.root + data[0].idd.suffixes[0];
                    setCountryCode(countryCode);
                })
                .catch((error) => console.error("Error fetching country code:", error));
        } else {
            setCountryCode("+1");
        }
    };

    const onChangeAddressLine1 = (text) => {
        setaddressLine1(text);
    };
    const onChangeAddressLine2 = (text) => {
        setaddressLine2(text);
    };
    const onChangeCity = (text) => {
        setcity(text);
    };
    const onChangeState = (text) => {
        setstate(text);
    };
    const onChangeZipCode = (text) => {
        setzipCode(text.replace(/[^0-9a-zA-Z ]+/g, ""));
    };
    const onChangeCountry = (text) => {
        setcountry(text);
    };

    const OnPressBtn = () => {
        let errorObj = {};
        const data = {
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            city: city,
            isActive: 1,
            mobileNumber: phone,
            pincode: zipCode,
            state: state,
            emailId: emailId,
            userId: userId,
            name: customerName,
            type: addressName,
            id: addressId,
            lat: coords?.lat,
            lng: coords?.lng,
            country: country,
        };
        if (customerName === "") {
            errorObj.customerName = true;
            errorObj.customerNameError = "This field is required";
        }
        if (addressName === "") {
            errorObj.addressName = true;
            errorObj.addressNameError = "This field is required";
        }
        if (phone === "") {
            errorObj.phone = true;
            errorObj.phoneError = "This field is required";
        }
        if (phone.length < 11) {
            errorObj.phone = true;
            errorObj.phoneError = "Invalid phone number provided";
        }
        if (addressLine1 === "") {
            errorObj.addressLine1 = true;
            errorObj.addressLine1Error = "This field is required";
        }
        if (city === "") {
            errorObj.city = true;
            errorObj.cityError = "This field is required";
        }
        if (state === "") {
            errorObj.state = true;
            errorObj.stateError = "This field is required";
        }
        if (zipCode === "") {
            errorObj.zipCode = true;
            errorObj.zipCodeError = "This field is required";
        }
        if (country === "") {
            errorObj.country = true;
            errorObj.countryError = "This field is required";
        }
        if (emailId === "") {
            errorObj.emailId = true;
            errorObj.emailIdError = "This field is required";
        }
        if (!REGEX.email.test(emailId)) {
            errorObj.emailId = true;
            errorObj.emailIdError = "Invalid email provided";
        }
        if (Object.keys(errorObj).length > 0) {
            setErrorObj(errorObj);
            return;
        }
        setLoading(true);
        dispatch(addNewAddress(data))
            .then((res) => {
                setLoading(false);
                if ([200]?.includes(res?.payload?.status)) {
                    if (isBilling) {
                        dispatch(
                            getAddressListAndUpdateBilling({
                                userId: userId,
                            })
                        );
                    } else {
                        dispatch(
                            getAddressListAndUpdateDelivery({
                                userId: userId,
                            })
                        );
                    }

                    if (isGuest) {
                        const eventData = {
                            address_type: isBilling ? "billing" : "shipping",
                        };
                        trackV2(ANALYTICS_EVENT_NAMES.GUEST_ADDRESS_ADDED, eventData);
                    } else {
                        const eventData = {
                            address_type: isBilling ? "billing" : "shipping",
                        };
                        trackV2(ANALYTICS_EVENT_NAMES.ADDRESS_SAVED, eventData);
                    }

                    trackV2(ANALYTICS_EVENT_NAMES.NEW_ADDRESS_ADDED, {});

                    if (redirectTo === "add-card") {
                        router.push(`/add-card?gender=${localGender}&addressId=${res?.payload?.data?.id}`);
                    } else if (isOrderSummaryCall) {
                        router.push(`/ordersummary?gender=${localGender}`);
                    } else if (isProfile) {
                        router.push(`/addresslist?type=profile&gender=${localGender}`);
                    } else {
                        router.push(`/addresslist?gender=${localGender}`);
                    }
                } else {
                    alert("Error");
                }
            })
            .catch((err) => {
                setLoading(false);
                // SimpleToast.show(t('Global.error'));
                console.log("err", err);
            });
    };

    const onBlurName = () => {
        setCustomerName(customerName.trim());
    };
    const onBlurPhone = () => {
        setphone(phone.trim());
    };
    const onBluraddress1 = () => {
        setaddressLine1(addressLine1.trim());
    };
    const onBluraddress2 = () => {
        setaddressLine2(addressLine2.trim());
    };
    const onBlurCity = () => {
        setcity(city.trim());
    };
    const onBlurState = () => {
        setstate(state.trim());
    };
    const onBlurZip = () => {
        setzipCode(zipCode.trim());
    };
    const onBlurCountry = () => {
        setcountry(country.trim());
    };

    const renderCountry = (selectedCountry, addressCountryModalRef) => {
        return (
            <View
                style={{
                    flexDirection: "row",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: spH(10),
                    marginBottom: spV(20),
                }}
            >
                <VText style={{ fontSize: fp(18), fontWeight: "350" }} text={"Shipping to :"} />
                <TouchableOpacity onPress={() => addressCountryModalRef.current.show()}>
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            backgroundColor: "#2124271A",
                            paddingHorizontal: spH(8),
                            paddingVertical: spV(8),
                            borderRadius: spH(8),
                        }}
                    >
                        <ImageView
                            source={selectedCountry.imageUrl}
                            style={{ width: 20, height: 20, marginLeft: 5, borderRadius: 100 }}
                            alt={selectedCountry.name}
                        />
                        <VText
                            text={selectedCountry.name}
                            style={{
                                color: Colors.black,
                                marginHorizontal: spH(10),
                                fontSize: fp(14),
                                fontWeight: "350",
                            }}
                        />
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 6L8 10L4 6"
                                stroke="black"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </View>
                </TouchableOpacity>
            </View>
        );
    };

    if (isProfile) {
        return (
            <ParentScrollView>
                <View style={Styles.profileAddressContainer}>
                    <VText style={Styles.header}>
                        {addressId ? "Edit Address" : isGuest ? "Add Shipping Address" : "Add New Address"}
                    </VText>
                    <View style={Styles.content}>
                        <SideProfileComp gender={localGender} selected="Saved Addresses" />
                        <View style={Styles.orderHistorySection}>
                            {renderCountry(selectedCountry, addressCountryModalRef)}

                            <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                                <View
                                    style={{
                                        marginRight: spH(20),
                                        width: "45%",
                                    }}
                                >
                                    <VText style={Styles.inputLabel} text={"Customer Name"} />
                                    <TextInput
                                        ref={nameInputRef}
                                        placeholder={"Customer Name"}
                                        placeholderTextColor={
                                            errorObj?.customerName ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                                        }
                                        style={[
                                            Styles.input,
                                            {
                                                borderColor: errorObj?.customerName
                                                    ? "rgba(206, 26, 26, 1)"
                                                    : "rgba(33, 36, 39, 0.3)",
                                            },
                                        ]}
                                        onBlur={onBlurName}
                                        value={customerName}
                                        onChangeText={(text) => {
                                            setCustomerName(text.replace(/\d+/g, ""));
                                        }}
                                        autoCorrect={false}
                                        onSubmitEditing={() => phoneInputRef.current.focus()}
                                        returnKeyType="next"
                                    />
                                    {errorObj?.customerName && (
                                        <VText
                                            style={[
                                                Styles.inputLabel,
                                                { color: "rgba(206, 26, 26, 1)", paddingTop: 16 },
                                            ]}
                                            text={errorObj?.customerNameError}
                                        />
                                    )}
                                </View>
                                <View style={{ width: "45%" }}>
                                    <VText style={Styles.inputLabel} text={"Address Name"} />
                                    <TextInput
                                        ref={nameInputRef}
                                        placeholder={"Address Name"}
                                        placeholderTextColor={
                                            errorObj?.addressName ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                                        }
                                        style={[
                                            Styles.input,
                                            {
                                                borderColor: errorObj?.addressName
                                                    ? "rgba(206, 26, 26, 1)"
                                                    : "rgba(33, 36, 39, 0.3)",
                                            },
                                        ]}
                                        onBlur={() => {
                                            setAddressName(addressName.trim());
                                        }}
                                        value={addressName}
                                        onChangeText={(text) => {
                                            setAddressName(text);
                                        }}
                                        autoCorrect={false}
                                        onSubmitEditing={() => phoneInputRef.current.focus()}
                                        returnKeyType="next"
                                    />
                                    {errorObj?.addressName && (
                                        <VText
                                            style={[
                                                Styles.inputLabel,
                                                { color: "rgba(206, 26, 26, 1)", paddingTop: 16 },
                                            ]}
                                            text={errorObj?.addressNameError}
                                        />
                                    )}
                                </View>
                            </View>
                            <View
                                style={{
                                    paddingVertical: spV(28),
                                }}
                            >
                                <VText style={Styles.inputLabel} text={"Phone Number"} />
                                <TextInput
                                    ref={phoneInputRef}
                                    placeholder={"Phone Number"}
                                    placeholderTextColor={
                                        errorObj?.phone ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                                    }
                                    style={[
                                        Styles.input,
                                        {
                                            borderColor: errorObj?.phone
                                                ? "rgba(206, 26, 26, 1)"
                                                : "rgba(33, 36, 39, 0.3)",
                                        },
                                    ]}
                                    onBlur={onBlurPhone}
                                    value={phone}
                                    maxLength={14}
                                    keyboardType="phone-pad"
                                    onChangeText={(text) => {
                                        onChangePhone(text.replace(/[^0-9+]+/g, ""));
                                    }}
                                    autoCorrect={false}
                                />
                                {errorObj?.phone && (
                                    <VText
                                        style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                                        text={errorObj?.phoneError}
                                    />
                                )}
                            </View>
                            <View
                                style={{
                                    paddingBottom: spV(20),
                                }}
                            >
                                <VText style={Styles.inputLabel} text={"Email"} />
                                <TextInput
                                    ref={phoneInputRef}
                                    placeholder={"Email"}
                                    placeholderTextColor={
                                        errorObj?.emailId ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                                    }
                                    style={[
                                        Styles.input,
                                        {
                                            borderColor: errorObj?.emailId
                                                ? "rgba(206, 26, 26, 1)"
                                                : "rgba(33, 36, 39, 0.3)",
                                        },
                                    ]}
                                    onBlur={onBlurPhone}
                                    value={emailId}
                                    keyboardType="email-address"
                                    onChangeText={(text) => {
                                        setEmailId(text);
                                    }}
                                    autoCorrect={false}
                                />
                                {errorObj?.emailId && (
                                    <VText
                                        style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                                        text={errorObj?.emailIdError}
                                    />
                                )}
                            </View>
                            <View
                                style={{
                                    paddingBottom: spV(28),
                                }}
                            >
                                <VText style={Styles.inputLabel} text={"Address Line 1"} />
                                <TextInput
                                    ref={addressLine1InputRef}
                                    placeholder={"Address Line 1"}
                                    placeholderTextColor={
                                        errorObj?.addressLine1 ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                                    }
                                    style={[
                                        Styles.input,
                                        {
                                            borderColor: errorObj?.addressLine1
                                                ? "rgba(206, 26, 26, 1)"
                                                : "rgba(33, 36, 39, 0.3)",
                                        },
                                    ]}
                                    onBlur={onBluraddress1}
                                    value={addressLine1}
                                    onChangeText={onChangeAddressLine1}
                                    autoCorrect={false}
                                    onSubmitEditing={() => addressLine2InputRef.current.focus()}
                                    returnKeyType="next"
                                />
                                {errorObj?.addressLine1 && (
                                    <VText
                                        style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                                        text={errorObj?.addressLine1Error}
                                    />
                                )}
                            </View>
                            <View
                                style={{
                                    paddingBottom: spV(28),
                                }}
                            >
                                <VText style={Styles.inputLabel} text={"Address Line 2"} />
                                <TextInput
                                    ref={addressLine2InputRef}
                                    placeholder={"Address Line 2"}
                                    placeholderTextColor={
                                        errorObj?.addressLine2 ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                                    }
                                    style={[
                                        Styles.input,
                                        {
                                            borderColor: errorObj?.addressLine2
                                                ? "rgba(206, 26, 26, 1)"
                                                : "rgba(33, 36, 39, 0.3)",
                                        },
                                    ]}
                                    onBlur={onBluraddress2}
                                    value={addressLine2}
                                    onChangeText={onChangeAddressLine2}
                                    autoCorrect={false}
                                    onSubmitEditing={() => cityInputRef.current.focus()}
                                    returnKeyType="next"
                                />
                                {errorObj?.addressLine2 && (
                                    <VText
                                        style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                                        text={errorObj?.addressLine2Error}
                                    />
                                )}
                            </View>
                            <View
                                style={{
                                    paddingBottom: spV(28),
                                    flexDirection: "row",
                                }}
                            >
                                <View
                                    style={{
                                        flex: 1,
                                        marginRight: spH(20),
                                    }}
                                >
                                    <VText style={Styles.inputLabel} text={"City"} />
                                    <TextInput
                                        ref={cityInputRef}
                                        placeholder={"City"}
                                        placeholderTextColor={
                                            errorObj?.city ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                                        }
                                        style={[
                                            Styles.input,
                                            {
                                                borderColor: errorObj?.city
                                                    ? "rgba(206, 26, 26, 1)"
                                                    : "rgba(33, 36, 39, 0.3)",
                                            },
                                        ]}
                                        onBlur={onBlurCity}
                                        value={city}
                                        onChangeText={onChangeCity}
                                        autoCorrect={false}
                                        onSubmitEditing={() => stateInputRef.current.focus()}
                                        returnKeyType="next"
                                    />
                                    {errorObj?.city && (
                                        <VText
                                            style={[
                                                Styles.inputLabel,
                                                { color: "rgba(206, 26, 26, 1)", paddingTop: 16 },
                                            ]}
                                            text={errorObj?.cityError}
                                        />
                                    )}
                                </View>
                                <View
                                    style={{
                                        flex: 1,
                                    }}
                                >
                                    <VText style={Styles.inputLabel} text={"State"} />
                                    <TextInput
                                        ref={stateInputRef}
                                        placeholder={"State"}
                                        placeholderTextColor={
                                            errorObj?.state ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                                        }
                                        style={[
                                            Styles.input,
                                            {
                                                borderColor: errorObj?.state
                                                    ? "rgba(206, 26, 26, 1)"
                                                    : "rgba(33, 36, 39, 0.3)",
                                            },
                                        ]}
                                        onBlur={onBlurState}
                                        value={state}
                                        onChangeText={onChangeState}
                                        autoCorrect={false}
                                    />
                                    {errorObj?.state && (
                                        <VText
                                            style={[
                                                Styles.inputLabel,
                                                { color: "rgba(206, 26, 26, 1)", paddingTop: 16 },
                                            ]}
                                            text={errorObj?.stateError}
                                        />
                                    )}
                                </View>
                            </View>
                            <View
                                style={{
                                    paddingBottom: spV(28),
                                    flexDirection: "row",
                                }}
                            >
                                <View
                                    style={{
                                        flex: 1,
                                        marginRight: spH(20),
                                    }}
                                >
                                    <VText style={Styles.inputLabel} text={"Zip Code"} />
                                    <TextInput
                                        placeholder={"Zip Code"}
                                        placeholderTextColor={
                                            errorObj?.zipCode ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                                        }
                                        style={[
                                            Styles.input,
                                            {
                                                borderColor: errorObj?.zipCode
                                                    ? "rgba(206, 26, 26, 1)"
                                                    : "rgba(33, 36, 39, 0.3)",
                                            },
                                        ]}
                                        onBlur={onBlurZip}
                                        // keyboardType="number-pad"
                                        maxLength={10}
                                        value={zipCode}
                                        onChangeText={onChangeZipCode}
                                        autoCorrect={false}
                                        onSubmitEditing={() => countryInputRef.current.focus()}
                                        returnKeyType="next"
                                    />
                                    {errorObj?.zipCode && (
                                        <VText
                                            style={[
                                                Styles.inputLabel,
                                                { color: "rgba(206, 26, 26, 1)", paddingTop: 16 },
                                            ]}
                                            text={errorObj?.zipCodeError}
                                        />
                                    )}
                                </View>
                                <View
                                    style={{
                                        flex: 1,
                                    }}
                                >
                                    <VText style={Styles.inputLabel} text={"Country"} />
                                    <TextInput
                                        ref={countryInputRef}
                                        editable={false}
                                        placeholder={"Country"}
                                        placeholderTextColor={
                                            errorObj?.country ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                                        }
                                        style={[
                                            Styles.input,
                                            {
                                                borderColor: errorObj?.country
                                                    ? "rgba(206, 26, 26, 1)"
                                                    : "rgba(33, 36, 39, 0.3)",
                                            },
                                        ]}
                                        onBlur={onBlurCountry}
                                        value={country}
                                        onChangeText={onChangeCountry}
                                        autoCorrect={false}
                                        returnKeyType="done"
                                    />
                                    {errorObj?.country && (
                                        <VText
                                            style={[
                                                Styles.inputLabel,
                                                { color: "rgba(206, 26, 26, 1)", paddingTop: 16 },
                                            ]}
                                            text={errorObj?.countryError}
                                        />
                                    )}
                                </View>
                            </View>
                            <Buttons
                                text={"Save Address"}
                                onPress={OnPressBtn}
                                // disabled={isDisabled}
                                loading={loading}
                                noBorder
                                containerStyle={[
                                    Styles.btn,
                                    {
                                        backgroundColor: isDisabled ? Colors.black30 : Colors.black,
                                        width: "40%",
                                    },
                                ]}
                            />
                        </View>
                    </View>
                </View>
                <AddressCountryModal
                    selectedCountry={selectedCountry}
                    handleCountryChange={handleCountryChange}
                    ref={addressCountryModalRef}
                />
            </ParentScrollView>
        );
    }

    return (
        <ParentScrollView>
            <View style={[Styles.container]}>
                <View
                    style={{
                        paddingBottom: hp(16),
                        borderBottomWidth: 1,
                        borderColor: "rgba(33, 36, 39, 0.3)",
                        marginBottom: hp(32),
                    }}
                >
                    <VText
                        style={{
                            fontSize: fp(28),
                            lineHeight: fp(34),
                            color: "rgba(33, 36, 39, 1)",
                            fontFamily: "LibreBodoni",
                        }}
                    >
                        {isGuest ? "Add Shipping Address" : "Add New Address"}
                    </VText>
                </View>
                {renderCountry(selectedCountry, addressCountryModalRef)}
                <View
                    style={{
                        flexDirection: "row",
                        paddingBottom: spV(28),
                    }}
                >
                    <View
                        style={{
                            marginRight: spH(20),
                            flex: 1,
                        }}
                    >
                        <VText style={Styles.inputLabel} text={"Customer Name"} />
                        <TextInput
                            ref={nameInputRef}
                            placeholder={"Customer Name"}
                            placeholderTextColor={
                                errorObj?.customerName ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                            }
                            style={[
                                Styles.input,
                                {
                                    borderColor: errorObj?.customerName
                                        ? "rgba(206, 26, 26, 1)"
                                        : "rgba(33, 36, 39, 0.3)",
                                },
                            ]}
                            onBlur={onBlurName}
                            value={customerName}
                            onChangeText={(text) => {
                                setCustomerName(text.replace(/\d+/g, ""));
                            }}
                            autoCorrect={false}
                            onSubmitEditing={() => phoneInputRef.current.focus()}
                            returnKeyType="next"
                        />
                        {errorObj?.customerName && (
                            <VText
                                style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                                text={errorObj?.customerNameError}
                            />
                        )}
                    </View>
                    <View
                        style={{
                            flex: 1,
                        }}
                    >
                        <VText style={Styles.inputLabel} text={"Address Name"} />
                        <TextInput
                            ref={nameInputRef}
                            placeholder={"Address Name"}
                            placeholderTextColor={
                                errorObj?.addressName ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"
                            }
                            style={[
                                Styles.input,
                                {
                                    borderColor: errorObj?.addressName
                                        ? "rgba(206, 26, 26, 1)"
                                        : "rgba(33, 36, 39, 0.3)",
                                },
                            ]}
                            onBlur={() => {
                                setAddressName(addressName.trim());
                            }}
                            value={addressName}
                            onChangeText={(text) => {
                                setAddressName(text);
                            }}
                            autoCorrect={false}
                            onSubmitEditing={() => phoneInputRef.current.focus()}
                            returnKeyType="next"
                        />
                        {errorObj?.addressName && (
                            <VText
                                style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                                text={errorObj?.addressNameError}
                            />
                        )}
                    </View>
                </View>
                <View
                    style={{
                        paddingBottom: spV(28),
                    }}
                >
                    <VText style={Styles.inputLabel} text={"Phone Number"} />
                    <TextInput
                        ref={phoneInputRef}
                        placeholder={"Phone Number"}
                        placeholderTextColor={errorObj?.phone ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"}
                        style={[
                            Styles.input,
                            {
                                borderColor: errorObj?.phone ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.3)",
                            },
                        ]}
                        onBlur={onBlurPhone}
                        value={phone}
                        maxLength={14}
                        keyboardType="phone-pad"
                        onChangeText={(text) => {
                            onChangePhone(text.replace(/[^0-9+]+/g, ""));
                        }}
                        autoCorrect={false}
                    />
                    {errorObj?.phone && (
                        <VText
                            style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                            text={errorObj?.phoneError}
                        />
                    )}
                </View>
                <View
                    style={{
                        paddingBottom: spV(20),
                    }}
                >
                    <VText style={Styles.inputLabel} text={"Email"} />
                    <TextInput
                        ref={phoneInputRef}
                        placeholder={"Email"}
                        placeholderTextColor={errorObj?.emailId ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"}
                        style={[
                            Styles.input,
                            {
                                borderColor: errorObj?.emailId ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.3)",
                            },
                        ]}
                        onBlur={onBlurPhone}
                        value={emailId}
                        keyboardType="email-address"
                        onChangeText={(text) => {
                            setEmailId(text);
                        }}
                        autoCorrect={false}
                    />
                    {errorObj?.emailId && (
                        <VText
                            style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                            text={errorObj?.emailIdError}
                        />
                    )}
                </View>
                <View
                    style={{
                        paddingBottom: spV(28),
                    }}
                >
                    <VText style={Styles.inputLabel} text={"Address Line 1"} />
                    <TextInput
                        ref={addressLine1InputRef}
                        placeholder={"Address Line 1"}
                        placeholderTextColor={errorObj?.addressLine1 ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"}
                        style={[
                            Styles.input,
                            {
                                borderColor: errorObj?.addressLine1 ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.3)",
                            },
                        ]}
                        onBlur={onBluraddress1}
                        value={addressLine1}
                        onChangeText={onChangeAddressLine1}
                        autoCorrect={false}
                        onSubmitEditing={() => addressLine2InputRef.current.focus()}
                        returnKeyType="next"
                    />
                    {errorObj?.addressLine1 && (
                        <VText
                            style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                            text={errorObj?.addressLine1Error}
                        />
                    )}
                </View>
                <View
                    style={{
                        paddingBottom: spV(28),
                    }}
                >
                    <VText style={Styles.inputLabel} text={"Address Line 2"} />
                    <TextInput
                        ref={addressLine2InputRef}
                        placeholder={"Address Line 2"}
                        placeholderTextColor={errorObj?.addressLine2 ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"}
                        style={[
                            Styles.input,
                            {
                                borderColor: errorObj?.addressLine2 ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.3)",
                            },
                        ]}
                        onBlur={onBluraddress2}
                        value={addressLine2}
                        onChangeText={onChangeAddressLine2}
                        autoCorrect={false}
                        onSubmitEditing={() => cityInputRef.current.focus()}
                        returnKeyType="next"
                    />
                    {errorObj?.addressLine2 && (
                        <VText
                            style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                            text={errorObj?.addressLine2Error}
                        />
                    )}
                </View>
                <View
                    style={{
                        paddingBottom: spV(28),
                        flexDirection: "row",
                    }}
                >
                    <View
                        style={{
                            flex: 1,
                            marginRight: spH(20),
                        }}
                    >
                        <VText style={Styles.inputLabel} text={"City"} />
                        <TextInput
                            ref={cityInputRef}
                            placeholder={"City"}
                            placeholderTextColor={errorObj?.city ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"}
                            style={[
                                Styles.input,
                                {
                                    borderColor: errorObj?.city ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.3)",
                                },
                            ]}
                            onBlur={onBlurCity}
                            value={city}
                            onChangeText={onChangeCity}
                            autoCorrect={false}
                            onSubmitEditing={() => stateInputRef.current.focus()}
                            returnKeyType="next"
                        />
                        {errorObj?.city && (
                            <VText
                                style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                                text={errorObj?.cityError}
                            />
                        )}
                    </View>
                    <View
                        style={{
                            flex: 1,
                        }}
                    >
                        <VText style={Styles.inputLabel} text={"State"} />
                        <TextInput
                            ref={stateInputRef}
                            placeholder={"State"}
                            placeholderTextColor={errorObj?.state ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"}
                            style={[
                                Styles.input,
                                {
                                    borderColor: errorObj?.state ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.3)",
                                },
                            ]}
                            onBlur={onBlurState}
                            value={state}
                            onChangeText={onChangeState}
                            autoCorrect={false}
                        />
                        {errorObj?.state && (
                            <VText
                                style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                                text={errorObj?.stateError}
                            />
                        )}
                    </View>
                </View>
                <View
                    style={{
                        paddingBottom: spV(28),
                        flexDirection: "row",
                    }}
                >
                    <View
                        style={{
                            flex: 1,
                            marginRight: spH(20),
                        }}
                    >
                        <VText style={Styles.inputLabel} text={"Zip Code"} />
                        <TextInput
                            placeholder={"Zip Code"}
                            placeholderTextColor={errorObj?.zipCode ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"}
                            style={[
                                Styles.input,
                                {
                                    borderColor: errorObj?.zipCode ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.3)",
                                },
                            ]}
                            onBlur={onBlurZip}
                            keyboardType="number-pad"
                            maxLength={5}
                            value={zipCode}
                            onChangeText={onChangeZipCode}
                            autoCorrect={false}
                            onSubmitEditing={() => countryInputRef.current.focus()}
                            returnKeyType="next"
                        />
                        {errorObj?.zipCode && (
                            <VText
                                style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                                text={errorObj?.zipCodeError}
                            />
                        )}
                    </View>
                    <View
                        style={{
                            flex: 1,
                        }}
                    >
                        <VText style={Styles.inputLabel} text={"Country"} />
                        <TextInput
                            ref={countryInputRef}
                            editable={false}
                            placeholder={"Country"}
                            placeholderTextColor={errorObj?.country ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.6)"}
                            style={[
                                Styles.input,
                                {
                                    borderColor: errorObj?.country ? "rgba(206, 26, 26, 1)" : "rgba(33, 36, 39, 0.3)",
                                },
                            ]}
                            onBlur={onBlurCountry}
                            value={country}
                            onChangeText={onChangeCountry}
                            autoCorrect={false}
                            returnKeyType="done"
                        />
                        {errorObj?.country && (
                            <VText
                                style={[Styles.inputLabel, { color: "rgba(206, 26, 26, 1)", paddingTop: 16 }]}
                                text={errorObj?.countryError}
                            />
                        )}
                    </View>
                </View>

                <Buttons
                    text={"Save and Use Address"}
                    onPress={OnPressBtn}
                    // disabled={isDisabled}
                    loading={loading}
                    noBorder
                    containerStyle={[Styles.btn, { backgroundColor: isDisabled ? Colors.black30 : Colors.black }]}
                />
            </View>
            <AddressCountryModal
                selectedCountry={selectedCountry}
                handleCountryChange={handleCountryChange}
                ref={addressCountryModalRef}
            />
        </ParentScrollView>
    );
};

export default AddAddress;

const Styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.white,
        paddingLeft: spH(200),
        paddingTop: spV(32),
        width: wp(750),
        paddingBottom: spV(40),
    },
    input: {
        borderColor: "rgba(33, 36, 39, 0.3)",
        borderWidth: 1,
        paddingHorizontal: spH(12),
        paddingVertical: spV(16),
        marginTop: spV(4),
        color: "rgba(33, 36, 39, 1)",
        fontSize: fp(16),
        lineHeight: fp(20),
        fontFamily: "JosefinSans",
        height: hp(44),
        outlineStyle: "none",
        fontWeight: "350",
    },
    btn: {
        alignSelf: "flex-start",
        width: "50%",
    },
    inputLabel: {
        color: "rgba(33, 36, 39, 1)",
        fontSize: fp(16),
        lineHeight: fp(20),
    },
    headerSmall: {
        alignSelf: "center",
        marginTop: spV(40),
        fontFamily: "LibreBodoni",
        fontSize: 20,
        lineHeight: 24,
        fontWeight: "500",
    },
    header: {
        textAlign: "center",
        fontSize: fp(28),
        fontFamily: "LibreBodoni",
        fontWeight: "350",
        marginBottom: spV(28),
    },
    content: {
        flex: 1,
        flexDirection: "row",
    },
    menuSection: {
        marginLeft: spH(70),
        width: "20%",
        paddingRight: spH(20),
        borderRightWidth: 1,
        borderRightColor: "#eee",
    },
    orderHistorySection: {
        width: wp(652),
        marginHorizontal: spH(80),
    },
    menuItem: {
        flexDirection: "row",
        alignItems: "center",
        height: spV(65),
        paddingRight: spH(16),
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
    },
    menuItemText: {
        fontSize: 16,
        marginLeft: 15,
        flex: 1,
    },
    chevron: {
        width: spH(15),
        height: spH(15),
        marginLeft: "auto",
    },
    menuItemIcon: {
        width: spH(21),
        height: spH(21),
    },
    profileAddressContainer: {
        flex: 1,
        backgroundColor: Colors.white,
        paddingTop: spV(32),
    },
    headerContainer: {
        paddingBottom: hp(28),
        borderBottomWidth: 1,
        borderColor: "rgba(33, 36, 39, 0.3)",
        marginBottom: hp(48),
    },
    headerText: {
        fontSize: fp(28),
        lineHeight: fp(34),
        color: "rgba(33, 36, 39, 1)",
    },
    headerContainer: {
        paddingBottom: hp(28),
        borderBottomWidth: 1,
        borderColor: "rgba(33, 36, 39, 0.3)",
        marginBottom: hp(48),
    },
    headerText: {
        fontSize: fp(28),
        lineHeight: fp(34),
        color: "rgba(33, 36, 39, 1)",
    },
});
